/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerFindAllQueryResponse, FoldersControllerFindAllQueryParams, FoldersControllerFindAll401, FoldersControllerFindAll403 } from "../../models/foldersController/FoldersControllerFindAll";

function getFoldersControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/folders` as const }  
  return res
}

/**
 * @summary Get all folders
 * {@link /api/v1/folders}
 */
export async function foldersControllerFindAll(params?: FoldersControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FoldersControllerFindAllQueryResponse, ResponseErrorConfig<FoldersControllerFindAll401 | FoldersControllerFindAll403>, unknown>({ method : "GET", url : getFoldersControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}